import Vue from 'vue';
import VueRouter from 'vue-router';
import RouterPrefetch from 'vue-router-prefetch'
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';
// Validation plugin used to validate forms
import ru from 'vee-validate/dist/locale/ru';
import VeeValidate, { Validator } from 'vee-validate';
import lang from 'element-ui/lib/locale/lang/ru-RU';
import locale from 'element-ui/lib/locale';

import swal from 'sweetalert2';

const axios = require('axios'); //почему-то не захотелл через import
axios.defaults.withCredentials = true;
const qs = require('querystring')

// router setup
import router from './routes/router';
import i18n from './i18n';
import './registerServiceWorker'
// plugin setup
import {eventEmitter} from "./plugins/globalComponents";
Vue.use(DashboardPlugin);
Vue.use(VueRouter);
Vue.use(RouterPrefetch);
Vue.use(VeeValidate, { fieldsBagName: 'veeFields' });
Validator.localize('ru', ru);
locale.use(lang);
Vue.use(require('vue-moment'));
import './plugins/validateRules';
import { Modal, BaseAlert } from 'src/components';
import { Cache } from './util/cache';
Vue.use(Modal);
Vue.use(BaseAlert);


/*
import initErrorHandler from './error';
initErrorHandler(Vue);
//*/

router.beforeEach((to, from, next) => {
	// console.log('router',from);
	SGVO.prevRoute = from.fullPath;
	//console.log('beforeEach',SGVO.prevRoute);
	// eventEmitter.$off('reload_tasks');
	// eventEmitter.$off('reload_lenta');
	next();
});
/*
router.beforeRouteEnter((to, from, next) => {
	next(vm => {SGVO.prevRoute = from;});
});
*/


Object.defineProperty(Vue.prototype,"$GVO",{
	get: function() {
		return this.$root.GVO;
	},
});

const unlinkObject=function(){
	if(window.structuredClone) return window.structuredClone;
	return function(obj){return JSON.parse(JSON.stringify(obj))};
}()

/* eslint-disable no-new */

const MD5 = function(d){
	d=unescape(encodeURIComponent(d));
	function M(d){for(var _,m="0123456789ABCDEF",f="",r=0;r<d.length;r++)_=d.charCodeAt(r),f+=m.charAt(_>>>4&15)+m.charAt(15&_);return f};
	function X(d){for(var _=Array(d.length>>2),m=0;m<_.length;m++)_[m]=0;for(m=0;m<8*d.length;m+=8)_[m>>5]|=(255&d.charCodeAt(m/8))<<m%32;return _};
	function V(d){for(var _="",m=0;m<32*d.length;m+=8)_+=String.fromCharCode(d[m>>5]>>>m%32&255);return _};
	function Y(d,_){
		d[_>>5]|=128<<_%32,d[14+(_+64>>>9<<4)]=_;
		for(var m=1732584193,f=-271733879,r=-1732584194,i=271733878,n=0;n<d.length;n+=16){
			var h=m,t=f,g=r,e=i;
			f=md5_ii(f=md5_ii(f=md5_ii(f=md5_ii(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_ff(f=md5_ff(f=md5_ff(f=md5_ff(f,r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+0],7,-680876936),f,r,d[n+1],12,-389564586),m,f,d[n+2],17,606105819),i,m,d[n+3],22,-1044525330),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+4],7,-176418897),f,r,d[n+5],12,1200080426),m,f,d[n+6],17,-1473231341),i,m,d[n+7],22,-45705983),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+8],7,1770035416),f,r,d[n+9],12,-1958414417),m,f,d[n+10],17,-42063),i,m,d[n+11],22,-1990404162),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+12],7,1804603682),f,r,d[n+13],12,-40341101),m,f,d[n+14],17,-1502002290),i,m,d[n+15],22,1236535329),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+1],5,-165796510),f,r,d[n+6],9,-1069501632),m,f,d[n+11],14,643717713),i,m,d[n+0],20,-373897302),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+5],5,-701558691),f,r,d[n+10],9,38016083),m,f,d[n+15],14,-660478335),i,m,d[n+4],20,-405537848),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+9],5,568446438),f,r,d[n+14],9,-1019803690),m,f,d[n+3],14,-187363961),i,m,d[n+8],20,1163531501),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+13],5,-1444681467),f,r,d[n+2],9,-51403784),m,f,d[n+7],14,1735328473),i,m,d[n+12],20,-1926607734),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+5],4,-378558),f,r,d[n+8],11,-2022574463),m,f,d[n+11],16,1839030562),i,m,d[n+14],23,-35309556),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+1],4,-1530992060),f,r,d[n+4],11,1272893353),m,f,d[n+7],16,-155497632),i,m,d[n+10],23,-1094730640),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+13],4,681279174),f,r,d[n+0],11,-358537222),m,f,d[n+3],16,-722521979),i,m,d[n+6],23,76029189),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+9],4,-640364487),f,r,d[n+12],11,-421815835),m,f,d[n+15],16,530742520),i,m,d[n+2],23,-995338651),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+0],6,-198630844),f,r,d[n+7],10,1126891415),m,f,d[n+14],15,-1416354905),i,m,d[n+5],21,-57434055),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+12],6,1700485571),f,r,d[n+3],10,-1894986606),m,f,d[n+10],15,-1051523),i,m,d[n+1],21,-2054922799),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+8],6,1873313359),f,r,d[n+15],10,-30611744),m,f,d[n+6],15,-1560198380),i,m,d[n+13],21,1309151649),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+4],6,-145523070),f,r,d[n+11],10,-1120210379),m,f,d[n+2],15,718787259),i,m,d[n+9],21,-343485551),m=safe_add(m,h),f=safe_add(f,t),r=safe_add(r,g),i=safe_add(i,e);
		}
		return Array(m,f,r,i)
	}
	function md5_cmn(d,_,m,f,r,i){return safe_add(bit_rol(safe_add(safe_add(_,d),safe_add(f,i)),r),m)};
	function md5_ff(d,_,m,f,r,i,n){return md5_cmn(_&m|~_&f,d,_,r,i,n)};
	function md5_gg(d,_,m,f,r,i,n){return md5_cmn(_&f|m&~f,d,_,r,i,n)};
	function md5_hh(d,_,m,f,r,i,n){return md5_cmn(_^m^f,d,_,r,i,n)};
	function md5_ii(d,_,m,f,r,i,n){return md5_cmn(m^(_|~f),d,_,r,i,n)};
	function safe_add(d,_){var m=(65535&d)+(65535&_);return(d>>16)+(_>>16)+(m>>16)<<16|65535&m};
	function bit_rol(d,_){return d<<_|d>>>32-_};
	let result=M(V(Y(X(d),8*d.length)));
	return result.toLowerCase()
};

const ApiCache = new Cache(MD5);

var GVO = new Vue({
	data() {
		let t_data={
			ps: [],
			endpoint_domen_api: (process.env.VUE_APP_LOCALHOST!=='1'?(location.protocol+'//'+location.hostname):'')+'/api/api.php',
			endpoint_domen: location.protocol+'//'+location.hostname,
			endpoint_doc_path: '/DATA/TASTS',
			endpoint_login_check: 'aucheck',
			endpoint_login: 'login',
			isLogined: false,
			isLoginFailed: false,
			login:'',
			password:'',
			curent_app:null,
			my_profile:{id:'',fio:'',company_name:''},
			api_call_history:[],
			cats:{},
			cats_loading_counter:0,
			api_loading_counter:0,
			router:{},
			test:0,
			app_errors:[],
			// объект предзагруженных состояний -  те данные которые должны загружатся при запуске приложения и которые должны быть доступны далее
			preload_data:{
				//str_tree: {status:0,data:{},url:'/data.php/desktopstructurestaff/storeTree',param:'',lastupdate:null}
			},
			wss:{},
			wss_channels:{},
			QSSN: [],
			ws_connectionClosed:0,
			notice:{
				chat_new:0,
				chats_mesaes:[],
				task_new:0,
				mail_new:0,
				notify_messages:[],
			},
			vsff:{v:3,r:''},
			TopNavbar:{},
			ats:{},
			PhoneBar:{},
			balance:'',
			iTechBalance: '',
			timerKeepAlive: null,
			masTreeOrgStruct: [],
			masTreeOrgStructWithStaff: [],
			HTTP_REFERER: '/data/main',
			fullscreenLoading:false,
			RUN_TASK_VER:-1,
			masBackTrace: [],
			objRequestCache: {},
			prevRoute: null,
			eventEmitter,
			Api:new Proxy({}, {
				get(target, objName){
					if(typeof objName === 'string'){
						return new Proxy({}, {
							get(target, name){
								if(typeof name === 'string'){
									return async (params={}, options={})=>{
										params.obj=objName
										return GVO.ApiCall(name,params, options);
									}
								}
							}
						})
					}
				}
			}),
		};
		
		Object.keys(t_data).forEach(key => {
			let internalValue = t_data[key]
			Object.defineProperty(t_data, key, {
				get() {
					return internalValue
				},
				set(newVal) {
					internalValue = newVal;
					//console.log('set GVO proerty '+key+' = '+newVal);
					eventEmitter.$emit('UPDATE_GVO_PROP',{p:key,v:newVal});
				}
			});
		});
		t_data.tmp_id = Date.now();
		return t_data;
	},
	computed:{
		isAdmin(){
			return (this.my_profile.adm == 1)
		},
	},
	methods:{
		getId(){
			return this.tmp_id++;
		},
		notifyVue(verticalAlign, horizontalAlign, message) {
			this.$notify({
				message:     message,
				timeout: 20000,
				icon: 'tim-icons icon-bell-55',
				horizontalAlign: horizontalAlign,
				verticalAlign: verticalAlign,
				type: 'info'
			});
		},

		isTest(){
			if(location.hostname.indexOf('test.')==0){
				return true;
			}
			return false;
		},
		str_replace: function(search, replace, subject){
			// str_replace("что заменяем", "чем заменяем", "исходная строка") //http://www.w3schools.com/jsref/jsref_replace.asp
			if (typeof subject != 'undefined'){
				return subject.split(search).join(replace);
			}
		},
		preload:function(){
			if(!this.isLogined){ return; }
			this.ApiCall('GET',{obj:'staff'})
				.then((objApi) => { 
					if(objApi.success === true){ //console.log(objApi);
						this.$set(this, 'my_profile', objApi.data[0]);
						eventEmitter.$emit('profile_load', objApi.data[0]);
						// console.log('this.my_profile', this.my_profile);
						// может перенести подписки в profile_load_cb();
						// Обновим оформление, если прилетит уведомление
						eventEmitter.$on('set_theme',(data)=>{
							this.my_profile.theme=data.theme;
							this.my_profile.sidebar_state=data.sidebar_state;
							this.my_profile.telegram_active=data.telegram_active;
							
							this.ApplyTheme();
						});
						eventEmitter.$on('new_lead',(data)=>{
							// console.log('new lead', data);
							let clientfio = '';
							let leadtype = 'Новый лид';
							let clientphone = GVO.formatPhoneNumber(data.lead.phone);
							if(data.lead.client_name && data.lead.client_patronymic && data.lead.client_surname){
								clientfio = ', клиент '+ data.lead.client_surname + ' ' + data.lead.client_name + ' ' + data.lead.client_patronymic;
							}else if(data.lead.client_name){
								clientfio = ', клиент '+ data.lead.client_name;
							}else {clientfio = '';}
							// if(clientfio !='' && clientfio !='0'){leadtype = 'Повторный звонок';}else {leadtype = 'Новый лид';} //нет, потому что напихали дурацкий Клиент_209379247
							// if(data.lead.client_id !=NULL && data.lead.client_id !='' && data.lead.client_id !='0'){leadtype = 'Повторный звонок';}else {leadtype = 'Новый лид';} // нет, потому что откуда-то есть ид клиента на первичном звонке??
							if(data.lead.client_name.includes("Клиент")){leadtype = 'Новый лид';} else {leadtype = 'Повторный звонок';}
							this.$notify({
								message: `<a href="/data/callcenter/id/${data.lead.id}/edit" style="color: #fff">${leadtype} ${clientphone} ${clientfio}</a>`,
								// message: `Новый лид ${data.lead.phone}, клиент ${clientfio}  <a href"/data/callcenter/id/${data.lead.id}/edit">открыть</a>`,
								timeout: 600000,
								icon: 'tim-ic ic-phone',
								type: 'info',
								closeOnClick: false
						  });							
						});
						
						this.profile_load_cb()
						this.ApplyTheme();
						this.wss = {};
						this.WSConnect();
					}
				}).catch(errorObjApi => console.error(errorObjApi));
			
			this.GetTreeOrgStruct();
			this.GetTreeOrgStructWithStaff();
			this.LoadCat('CAT_DIST',true);
			this.LoadCat('cat_districts',true);
			this.LoadCat('CAT_METRO',true);
			this.LoadCat('CAT_DIRECTIONS',true);
			this.LoadCat('CAT_ROOMS',true);
			this.LoadCat('CAT_STAFF',true);
			this.LoadCat('CAT_ContractTypes',true);
			this.LoadCat('CAT_FlatTypes',true);
			this.LoadCat('CAT_BP_TASK_TAGS',true);
			this.LoadCat('CAT_FORMFIELDS_TYPE',true);
			this.LoadCat('CAT_FORMFIELD_NAMES',true);

			this.ApiCall('GET_CONTACTS_TYPES',{obj:"client"})
				.then((objApi) => { 
					//console.log('GET_CONTACTS_TYPES',objApi);
					if(objApi.success === true){
						this.cats['CONTACTS_TYPES'] = objApi.data;
					}
				}).catch(errorObjApi => {console.error(errorObjApi);});

			for(let nloading in this.preload_data){
				if(this.preload_data[nloading].status < 2){
					this.preload_data[nloading].status=1;
					this.ApiCall(this.preload_data[nloading].url,this.preload_data[nloading].param)
					.then(e=> { this.preload_data[nloading].data=e; this.preload_data[nloading].status=2; })
					.catch(e=>{ console.error(e);});
				}
			}
		},
		WSConnect:  function(){
			/*
			let port = '9082';
			if(!this.isTest()) port = '9081';
			this.wss = new WebSocket('wss://'+location.hostname+':'+port+'/');
			//*/
			this.wss = new WebSocket('ws'+(location.protocol=='https:'?'s':'')+'://'+location.hostname+':'+location.port+'/wss/');
			// this.wss = new WebSocket('wss://'+location.hostname+'/wss/');
			this.wss.realClose = (data) =>{
				SGVO.ws_connectionClosed = 1;
				SGVO.wss.close();
			}
			this.wss.ssend = (data) => {
				if(typeof data == 'object'){
					data = JSON.stringify({...data, ...{user:this.my_profile.login}});
				}
				if(this.QSSN.length == 0 && this.wss.readyState == 1){
					if(this.wss.bufferedAmount == 0){
						if(data.indexOf('"method":"KEEPALIVE"') == -1){
							// console.log('>> '+data);
						}
						//SendConfirmation(data);
		                this.wss.send(data);
					}else{
						this.QSSN.push(data);
					}
				}else{
					if(this.wss.readyState == 2 || this.wss.readyState == 3){
						//return false;
					}
					this.QSSN.push(data);
				}
			}
			this.wss.onmessage  = (evt) => { 
				//console.log('WSConnect.onmessage',evt);
				if(evt.data != ''){
					let obj_from_wsjson = this.SafeParseJson(evt.data);
					if( obj_from_wsjson.type != "ok"){
						// console.log('WSConnect.onmessage',obj_from_wsjson);
						if( obj_from_wsjson.type == "error"){
							this.ws_connectionClosed = 1;
						} else if(obj_from_wsjson.type == "chatMessage" || obj_from_wsjson.type == "notifyTip" || obj_from_wsjson.type == "callInfo"){
							this.WSNotifys(obj_from_wsjson);
						}else if(obj_from_wsjson.type == "reload_tasks"){
							//this.WSNotifys(obj_from_wsjson);
							// console.log('websocket пришел',obj_from_wsjson.type);
							if(typeof obj_from_wsjson.dopFields.RUN_TASK_VER != 'undefined'){
								if(parseInt(obj_from_wsjson.dopFields.RUN_TASK_VER) > this.RUN_TASK_VER){
									// console.log('websocket выполнил',obj_from_wsjson.type);
									this.RUN_TASK_VER = parseInt(obj_from_wsjson.dopFields.RUN_TASK_VER);
									eventEmitter.$emit(obj_from_wsjson.type,obj_from_wsjson);
								}
							} else {
								// console.log('websocket выполнил',obj_from_wsjson.type);
								this.RUN_TASK_VER = -1;
								eventEmitter.$emit(obj_from_wsjson.type,obj_from_wsjson);
							}
						}else if(obj_from_wsjson.type == "reload_lenta"){
							eventEmitter.$emit(obj_from_wsjson.type,obj_from_wsjson);
						}else if(obj_from_wsjson.type == "data"){
							try{
								const data=JSON.parse(obj_from_wsjson.text);

								if(data.type)	
									eventEmitter.$emit(data.type,data);
							}catch(e){
								console.error(e);

							}
					
						}else{

						}
					}else{
						//летит кипалив или что-то не важное
					}
				}
			};
			this.wss.onopen = (evt) => {
				this.ws_connectionClosed = 0;
				this.wss.ssend({method:'rememberme'});
				//let channels=Object.keys(this.wss_channels);
				//channels.forEach(channel=>this.wss.send({method}))
				setInterval(function() {
					if (SGVO.wss.bufferedAmount == 0) {  if(SGVO.QSSN.length > 0){ SGVO.wss.send(SGVO.QSSN.splice(0,1)); } }
				}, 50);
			}
			this.wss.onclose = function() {  
				// console.log('CONNECTION CLOSED'); 
				SGVO.wss.close(); 
				SGVO.wss = {};
				if(SGVO.ws_connectionClosed == 0){ 
					setTimeout(function(){
						// console.log('RECONNECT CONNECTION'); 
						SGVO.wss={}; 
						SGVO.WSConnect(); 
					}, 1000); 
				}
			};
		},
		WSNotifys(obj_from_ws){
			// console.log('WSNotifys',obj_from_ws);
			this.$notify({
				type: 'primary',
				message: `${obj_from_ws.text}`,
				icon: 'tim-icons icon-bell-55'
			});
			/*
			if(obj_from_ws.type=="chatMessage"){
				this.notice.chat_new = this.notice.chat_new+1;
				//document.getElementById('bzdin').play();
				eventEmitter.$emit(obj_from_ws.type,obj_from_ws);
			}
			*/
		},
		CreateApiMethod: function(strMetodName, objParams={id:"594bd818191bd85c7241b55a5d320b28"},qId=0){
			let objRet = {jsonrpc:"2.0",id:qId,method:"",params:{}};
			objRet.method = strMetodName;
			objRet.params = objParams;
			return objRet;
		},
		axiosSend(strSendParams){
			//let objSend = {json:JSON.stringify([{"jsonrpc":"2.0","id":"1","method":"GET_CONTACTS","params":{"obj":"staff","flt":{"code":"8136"}}},{"jsonrpc":"2.0","id":"1","method":"GET_CONTACTS","params":{"obj":"staff","flt":{"code":"2601"}}}])};
			let objSend = {json:strSendParams};
			return new Promise(function(resolve, reject) {
				axios.post(GVO.endpoint_domen_api, qs.stringify(objSend),{headers: {accept: 'application/json','Content-Type': 'application/x-www-form-urlencoded'}})
					.then((response) => {
						//console.log(response);
						resolve(response.data);
					}).catch((error) => {
						console.error(error);
						reject(false);
					});
			});
		},
		async UploadFile(strFormId,strMethod,objApiParams){
			const objApi = JSON.stringify(this.CreateApiMethod(strMethod,objApiParams));
			let uploadForm = new FormData(document.getElementById(strFormId));
			uploadForm.append('json', objApi);
			let masFiles = [];
			let objResponses = {"success": false,"data": []};
			for(let [name, value] of uploadForm) {
				//console.log(name,value);
				if(name.indexOf('in_files')!=-1) masFiles.push(value);
			}

			if(masFiles.length>1){
				for(let [name, value] of uploadForm) {
					if(name.indexOf('in_files')!=-1) uploadForm.delete(name);
				}

				for (let i = 0; i < masFiles.length; i++) {
					uploadForm.append(`in_files[${i}]`, masFiles[i]);
					objResponses.success = false;
					await axios.post(GVO.endpoint_domen_api, uploadForm, { headers: { 'Content-Type': 'multipart/form-data' } })
								.then(response => 	{  
									//console.log(response.data.result);
									objResponses.success = true;
									objResponses.data.push(response.data.result.data);
								})
								.catch(error => 	{  console.error(error.response); objResponses.success = false;});
					uploadForm.delete(`in_files[${i}]`);
				}
				//console.log(objResponses);
				return new Promise(function(resolve,reject){
					if(objResponses.success===true){
						resolve(objResponses);
					} else {
						reject(false);
					}	
				});
			}
			
			return new Promise(function(resolve,reject){
				axios.post(GVO.endpoint_domen_api, uploadForm, { headers: { 'Content-Type': 'multipart/form-data' } })
					.then(response => 	{  
						//console.log(response.data.result);
						resolve(response.data.result);
					})
					.catch(error => 	{  console.error(error.response); reject(error.response); });
			});
			
		},
		checkLogin: function(start_app){
			if (start_app === undefined) { start_app=false; }
			const MY_HTTP_REFERER = this.str_replace(location.origin,'',location.href);
			let objSend = {json:JSON.stringify(this.CreateApiMethod(this.endpoint_login_check,{'MY_HTTP_REFERER':MY_HTTP_REFERER}))};
			axios.defaults.withCredentials = true;
			//axios.post(this.endpoint_domen_api, this.CreateApiMethod(this.endpoint_login_check))
			//axios.post(this.endpoint_domen_api+'?json='+JSON.stringify(this.CreateApiMethod(this.endpoint_login_check)))
			axios.post(this.endpoint_domen_api,qs.stringify(objSend),{headers: {accept: 'application/json','Content-Type': 'application/x-www-form-urlencoded'}})
			//this.ApiCall(this.endpoint_login_check)
				.then((response) => {
					//console.log(response);
					let isOk = false;
					if(typeof response.data.result.success != 'undefined'){
						isOk = response.data.result.success;
					} else {
						isOk = response.data.result;
					}
					if(isOk){
						this.isLogined = true;
						GVO.server_config = response.data.result.data;
						this.preload();
						this.startTimerKeepAlive();
						if (start_app){
							GVO.router=router;
							this.curent_app = new Vue({
								el: '#all_page',
								router,
								i18n,
								data: {
									GVO: GVO // Here we bind our event bus to our $root Vue model.
								},
								render: h => h(App)
							});
						}
					}else{
						this.isLogined = false;
						this.stopTimerKeepAlive();
						let http_ref = '/data/main';
						//console.log(response.data.result.data.HTTP_REFERER);
						if(typeof response.data.result.data.HTTP_REFERER != 'undefined' && response.data.result.data.HTTP_REFERER != ''){
							http_ref = response.data.result.data.HTTP_REFERER;
							//console.log(http_ref);
							if(typeof http_ref.split('/data')[1] != 'undefined'){
								http_ref = '/data'+http_ref.split('/data')[1];
							}else{
								http_ref = '/data/main';
							}
						}
						if (start_app){
							GVO.router=router;
							GVO.HTTP_REFERER = http_ref
							this.curent_app = new Vue({
								el: '#app_login',
								router,
								i18n,
								data: {
									GVO: GVO // Here we bind our event bus to our $root Vue model.
								},
								render: h => h(App)
							});
						}
					}
				}).catch((error) => {
					console.error(error);
				});
		},
		Login: function(){
			//console.log(GVO.HTTP_REFERER); return;
			this.ApiCall(this.endpoint_login,{login:this.login,password:this.password})
			.then((response) => { //console.log(response); return;
				if(response.success){ //console.log(response);
					this.isLogined=true;
					this.isLoginFailed = false;

					this.preload();
					this.startTimerKeepAlive();
					//console.log(GVO.HTTP_REFERER);
					if(typeof GVO.HTTP_REFERER != 'undefined' && GVO.HTTP_REFERER != ''){
						location.href = GVO.HTTP_REFERER;
						//GVO.HTTP_REFERER = '';
					} else {
						location.href = '/data/main';
					}
				}else{
					// login failed
					this.isLogined=false;
					this.isLoginFailed = true;
					eventEmitter.$emit('LOGIN_FAILED',{success:false});
				}
			})
			.catch((error) => {
				this.isLogined=false;
				this.isLoginFailed = true;
				console.error(error);
			});
		},
		LogOut: function(){
			this.ApiCall('logout')
				.then((objApi) => {  
					if(objApi.success){
						GVO.objRequestCache = {};
						if(typeof this.wss.close == 'function') {this.wss.close(); this.wss = {};}
						this.isLogined=false;
						this.isLoginFailed = false;
						this.my_profile = {};
						this.stopTimerKeepAlive();
						location.href='/';
					}else{
						alert('LogOut не удался');
					}
				}).catch(errorObjApi => console.error(errorObjApi));
		},
		HELP: function(strClass=''){
			if(strClass !=''){
				GVO.ApiCall('HELP',{obj:strClass})
					.then((objApi) => {  
						// console.log(objApi.data);
					 })
					.catch(errorObjApi => console.error(errorObjApi));
			}
		},
		CheckCache(strQuery,objData={}){
			var result=MD5(strQuery);
			let masMethodBlackList=['LOGIN','AUCHECK','KEEPALIVE','LOGOUT','CLIENT.GET_LENTA','UNREAD'];
			let objQuery = this.SafeParseJson(strQuery);
			if(typeof objQuery.method != 'undefined'){
				if(masMethodBlackList.indexOf(objQuery.method.toUpperCase()) == -1 ){
					if(result in GVO.objRequestCache){
						if (!this.isEmpty(objData) && this.isEmpty(GVO.objRequestCache[result].ret)) {
							if(objData.success === true)
								GVO.objRequestCache[result]={'qu':this.unlinkObject(objQuery),'ret':this.unlinkObject(objData)};
						}else if(!this.isEmpty(GVO.objRequestCache[result].ret)){
							return this.unlinkObject(GVO.objRequestCache[result].ret);
						}
					}else{
						GVO.objRequestCache[result]={'qu':this.unlinkObject(objQuery),'ret':this.unlinkObject(objData)};
					}
				}
			}
			return false;
		},
		ApiCall: function(strMethod,objParam='',options={}){
			//console.log('API ', strMethod, objParam);
			/* //как использовать:
				this.ApiCall('logout')
					.then((objApi) => {  console.log(objApi); })
					.catch(errorObjApi => console.log(errorObjApi));
				// или 
				this.ApiCall(this.endpoint_login,{login:this.login,password:this.password})
					.then((objApi) => {  console.log(objApi); })
					.catch(errorObjApi => console.log(errorObjApi));
				// или 
				this.$GVO.ApiCall('login',{login:this.login,password:this.password})
					.then((objApi) => {  console.log(objApi); })
					.catch(errorObjApi => console.log(errorObjApi));
				// или когда сразу несколько методов В ОДНОМ ЗАПРОСЕ
				this.$GVO.ApiCall(['GET','GET_CONTACTS'],[{obj:'staff' ,flt:{code:this.$route.params.code}},{obj:"staff",flt:{code:this.$route.params.code}}])
					.then((objApi) => {  
						console.log(objApi); 
						if(objApi[0].result.success === true){
							this.masStaff = objApi[0].result.data;
							this.masStaff[0].masDopContacts = [];
						}
						if(objApi[1].result.success === true){
							this.masStaff[0].masDopContacts = objApi[1].result.data;
						}
					})
					.catch(errorObjApi => console.log(errorObjApi));
			*/
			let arrExludeLoadMethods = ['KEEPALIVE','unread','billing.getTechBalance'];
			let objMethodParams = {};
			if(objParam == ''){
				objMethodParams = this.CreateApiMethod(strMethod);
			}else{
				if(typeof strMethod == 'string'){
					objMethodParams = this.CreateApiMethod(strMethod,objParam);
				} else {
					objMethodParams = [];
					for (let i = 0; i < strMethod.length; i++) {
						const strM = strMethod[i];
						const objP = objParam[i];
						objMethodParams.push(this.CreateApiMethod(strM,objP,i));
					}
				}
			}

			if(strMethod=='fake_true'){
				return new Promise(function(resolve, reject) { 
					let retobj = {}; retobj['success']=true; retobj['data']=""; 
					return resolve(retobj); 
				});
			}
			let query;
			let json = JSON.stringify(objMethodParams);
			if (options.useCache){
				query = ApiCache.get(json);
			}
			/*
			let dmpCacheCheck = GVO.CheckCache(JSON.stringify(objMethodParams));
			if(dmpCacheCheck !== false){
				//console.log('dmpCacheCheck',dmpCacheCheck);
			}
			/*
			if(dmpCacheCheck !== false){
				return new Promise(function(resolve, reject) { 
					return resolve(dmpCacheCheck); 
				});
			}
			*/
			if(!query){
				this.api_loading_counter++;

				query = new Promise(function(resolve,reject){

					var retobj = {};
					retobj['success']=false;
					retobj['msg']='Initial state';

					if(strMethod === undefined) { 
						retobj['success']=false;
						retobj['msg']='Query is null';
						reject(retobj);
					}
					if(!GVO.isLogined && (strMethod != GVO.endpoint_login)){ 
						retobj['success']=false;
						retobj['msg']='Not login';
						reject(retobj);
					}
					axios.defaults.withCredentials = true;
					//console.log('strMethod',strMethod);
					if(arrExludeLoadMethods.indexOf(strMethod)==-1)	{
						// document.getElementsByTagName('body')[0].style.cursor='wait'; 
						GVO.fullscreenLoading = true;
					}
					let objSend = {json};
					axios.post(GVO.endpoint_domen_api, qs.stringify(objSend),{headers: {accept: 'application/json','Content-Type': 'application/x-www-form-urlencoded'}})
					//axios.post(GVO.endpoint_domen_api+'?json='+JSON.stringify(objMethodParams))
						.then((response) => { GVO.api_loading_counter--;
							//if(GVO.api_loading_counter<1){GVO.fullscreenLoading = false;}
							//console.log(response); //return response;
							if(response.status === 200){
								retobj=response;
								GVO.api_call_history.push({time:Date(),url:strMethod,post:objParam,resp:response});
								if(GVO.api_loading_counter<1){
									// document.getElementsByTagName('body')[0].style.cursor=''; 
									GVO.fullscreenLoading = false;
									// document.querySelectorAll('.el-loading-parent--hidden').forEach(el => el.classList.remove('el-loading-parent--hidden'));
								}
								// console.log(response);
								if(response && response.data && response.data.result && typeof response.data.result.ClientNotify != 'undefined'){
										// console.log(response.data.result.ClientNotify);
										this.notifyVue('top', 'right', response.data.result.ClientNotify);												
								}	
								if(typeof response.data.length == 'undefined'){
									if(typeof response.data.result.back_trace_json != 'undefined'){
										//console.log('apicall',response.data.result.back_trace_json);
										GVO.masBackTrace = response.data.result.back_trace_json;
									}
									if(response.data.result.success == false){ 
										//this.app_errors.push(response.data);
										if(response.data.result.msg == 'the session is over'){
											//alert('сессия уже завершена');
											// console.log('######## response.data.result.success - FALSE ######### сессия уже завершена')
											// console.log(response);
											GVO.stopTimerKeepAlive();
											// debugger;
											location.reload();
										}else{
											// console.log('######## response.data.result.success - FALSE ######### '+response.data.result.msg)
											//console.log(response.data);
											if(typeof response.data.result.ClientMsg != 'undefined'){
												if(response.data.result.ClientMsg.type == 'error'){
														GVO.showAlert('ОШИБКА',`<div>
														${response.data.result.ClientMsg.msg}
														</div>`);
														//console.log('huita '+response.data.result.ClientMsg.msg) // huita [object Object]
												}
											}
											/*
											let ret = confirm(response.data.result.msg+"\r\n\r\n Обновить страницу? Все введенные данные будут потеряны.");
											if(ret){
												location.reload();
											}
											*/
										}
									}else{
										if(typeof response.data.result.ClientMsg != 'undefined'){
											if(response.data.result.ClientMsg.type == 'info'){
												GVO.showAlert('Информация',`<div>${response.data.result.ClientMsg.msg}</div>`,'btn btn-info btn-fill');
											}
										}
									}

									GVO.CheckCache(JSON.stringify(objMethodParams), retobj.data.result);
									eventEmitter.$emit(strMethod,{param:objParam,result:retobj});
									//document.getElementsByTagName('body')[0].style.cursor=''; GVO.fullscreenLoading = false;
									resolve(retobj.data.result);
								} else {
									//console.log('apicall more then one querry',response);
									for (let i = 0; i < response.data.length; i++) {
										if(response.data[i].result.success == false){ 
											//this.app_errors.push(response.data);
											if(response.data[i].result.msg == 'the session is over'){
												// console.log('######## response.data.result.success - FALSE ######### сессия уже завершена')
												// console.log(response);
												GVO.stopTimerKeepAlive();
												// debugger;
												location.reload();
												break;
											}else{
												// console.log('######## response.data.result.success - FALSE ######### ['+i+'] '+response.data[i].result.msg)
											}
										}
										eventEmitter.$emit(strMethod[i],{param:objParam[i],result:retobj.data[i]});
									}
									GVO.CheckCache(JSON.stringify(objMethodParams), retobj.data);
									//document.getElementsByTagName('body')[0].style.cursor=''; GVO.fullscreenLoading = false;
									resolve(retobj.data);
								}
								//document.getElementsByTagName('body')[0].style.cursor=''; GVO.fullscreenLoading = false;
								//eventEmitter.$emit(strMethod,{param:objParam,result:retobj});
								//resolve(retobj.data.result);
							}
						})
						.catch((error) => { GVO.api_loading_counter--;
							if(GVO.api_loading_counter<1){
								GVO.fullscreenLoading = false;
								// document.querySelectorAll('.el-loading-parent--hidden').forEach(el => el.classList.remove('el-loading-parent--hidden'));
							}
							//console.log(error);
							retobj['success']=false;
							retobj['msg']=error;
							document.getElementsByTagName('body')[0].style.cursor='';
							//console.log(error);
							/*app_errors.push(error);*/ 
							// alert(error);
							//location.reload();
							ApiCache.del(json);
							if(typeof retobj.data != 'undefined'){
								reject(retobj.data.result);
							}else{
								reject(retobj);
							}
						});
				});
				ApiCache.set(json, query);
			}

			return query;
		},
		parseQueryString:function(str, array){ // Parses the string into variables
			if(str==undefined || typeof str == undefined){	str=location.search;	}
				var glue1 = '=';
				var glue2 = '&';
				if(str[0]=='?'){ str=str.substr(1); }
				var array2 = str.split(glue2); //console.log(array2);
				var array3 = {};
				if(array2.length == 1 && array2[0] == ''){
					return {};
				}else{
					for(var x=0; x<array2.length; x++){
						var tmp = array2[x].split(glue1);
						//array3[decodeURI(tmp[0])] = decodeURI(tmp[1]);
						array3[decodeURIComponent(tmp[0])] = decodeURIComponent(tmp[1]);
					}
				}
			if(array){
				array = array3;
			} else{
				return array3;
			}
		},
		ObjToQueryString:function(InArr){
			var retstr='';
			for(var el in InArr){
				if(el != '' && InArr[el]!= undefined){
					retstr+='&'+el+'='+InArr[el];
				}
			}
			return retstr;
		},
		GetGetVar:function(k,getstr){
			if(getstr==undefined){ getstr = location.search;}
			let t = this.parseQueryString(getstr);
			return decodeURI(t[k]);
		},
		GetAllGet:function(getstr){
			if(getstr==undefined){ getstr = location.search;}
			return this.parseQueryString(getstr);
		},
		CreateIndexReq:function(invar,path,retarr){
		    // console.log('CreateIndexReq');
	    	    if(invar instanceof Array){
	        	for(let i_noda in invar){
		    	    this.CreateIndexReq(invar[i_noda],path,retarr);
			}
	    	    }else{
			if(invar.children != undefined && invar.children != null && invar.children.length > 0){
		    	    //console.log(path+' => '+invar.name);
			    retarr[path+' => '+invar.name]=invar;
			    this.CreateIndexReq(invar.children,path+' => '+invar.name,retarr);
			}else{
			    //console.log(path+' => '+invar.name);
			    retarr[path+' => '+invar.name]=invar;
			}
			//попытка добавить собрудников
			/*
			if(invar.staffs != undefined && invar.staffs != null && invar.staffs > 0){
			    for(let i_noda_s in invar.staffs){
				retarr[path+' => '+i_noda_s.fio]=i_noda_s;
			    }
			}
			*/
	    	    }
		},
		SeachTreeReq:function(tree,k,v,retarr){
			//console.log('SeachTreeReq');
			/* Ищет рекурсивно по массиву, параетры 1-дерево для поиска, 2-название своства в узле дерева, 3-его значение, 4-куда отдать результат */
			if(tree instanceof Array){
				for(let i_noda in tree){
					this.SeachTreeReq(tree[i_noda],k,v,retarr);
				}
			}else{
				if(tree!=undefined && tree[k]!=undefined && tree[k]==v){ retarr.push(tree); }
				if(tree!=undefined && tree.children != undefined && tree.children != null && tree.children.length > 0){
					this.SeachTreeReq(tree.children,k,v,retarr);
				}
			}
		},
		toBool:function(v){
			if(v==true){return true;}
			if(v=="true"){return true;}		
			if(v=="TRUE"){return true;}		
			if(v==1){return true;}		
			return false;
		},
		trim:function( str, charlist ) {
				charlist = !charlist ? ' \s\xA0' : charlist.replace(/([\[\]\(\)\.\?\/\*\{\}\+\$\^\:])/g, '\$1');
				let re = new RegExp('^[' + charlist + ']+|[' + charlist + ']+$', 'g');
				return str.replace(re, '');
		},
		SafeParseJson:function(txt){
			try {
				return JSON.parse(txt);
			} catch (err) {
				console.error('Error safe parse json',txt);
				//console.log(err);
				return {};
			}
		},
		convertDateFromMysql: function(dt){
			if(typeof dt !='undefined'){
				let dtarr = dt.split('-');
				return dtarr[2]+'.'+dtarr[1]+'.'+dtarr[0];
			}
			return false;
		},
		convertDateTimeFromMysql: function(dt){
			//console.log(dt);
			if(typeof dt != 'undefined' && dt != null){
				let dt1=dt.split(' ');
				let dtarr = dt1[0].split('-');
				if(dtarr[2] == undefined){ return dtarr[0]+' '+dt1[1]; }
				return dtarr[2]+'.'+dtarr[1]+'.'+dtarr[0]+' '+dt1[1];
			}
			return false;
		},
		convertDateTimeFromMysqlToDate: function(dt){
			// console.log(dt);
			if(typeof dt != 'undefined' && dt != null){
				let dt1=dt.split(' ')[0];				
				let dtarr = dt1.split('-');
				return dtarr[2]+'.'+dtarr[1]+'.'+dtarr[0];
			}
			return false;
		},
		convertTimeDateFromMysql: function(dt){
			//console.log(dt);
			if(typeof dt != 'undefined' && dt != null){
				let dt1=dt.split(' ');
				let dtarr = dt1[0].split('-');
				if(dtarr[2] == undefined){ return dtarr[0]+' '+dt1[1]; }
				return dt1[1].substr(0,5)+' '+dtarr[2]+'.'+dtarr[1]+'.'+dtarr[0];
			}
			return false;
		},
		isEmpty(field){
			if(typeof field != 'undefined'){
				if(field != 'undefined' && field != null && typeof field != 'object'){
					if(field != ''){
						return false;
					}
					if (typeof field == 'boolean') {
						return false;
					}
				} else if(field != 'undefined' && field != null && typeof field == 'object'){
					try {
						let masKeys = Object.keys(field);
						if(masKeys.length > 0){
							return false;
						}	
					} catch (error) {
						
					}
				} else if(field != 'undefined' && field != null && typeof field == 'array'){
					if(field.length > 0){
						return false;
					}
				}
			}
			return true;
		},
		GetSklonCount(strType,chislo){
			chislo = chislo.toString();
			let str1 = '';
			let str2 = '' ;
			let str3 = '';
			if(chislo.length == 1){ chislo = '0'+chislo; }
			let razrad = chislo.substr(-2,2);
			switch(strType){
				case 'options':
					str1 = 'опция';
					str2 = 'опции';
					str3 = 'опций';
					break;
			}
			if(str1 == '') return '';

			if( razrad.substr(0,1) == '0' || razrad.substr(0,1) == '1'){
				if(razrad == '01'){ return ' '+str1; }
				if(razrad == '02' || razrad == '03' || razrad == '04'){ return ' '+str2; }
				return ' '+str3;
			}else{
				if(razrad.substr(-1,1) == '0'){ return ' '+str3; }
				if(razrad.substr(-1,1) == '1'){ return ' '+str1; }
				if(razrad.substr(-1,1) == '2' || razrad.substr(-1,1) == '3' || razrad.substr(-1,1) == '4'){ return ' '+str2; }
				return ' '+str3;
			}
		},
		LoadCat(cat_name, forse=false){
			if(cat_name.length==0){ return false; }
			if(this.cats[cat_name] == undefined || forse){ 
				this.cats_loading_counter++;
				GVO.ApiCall('GET',{obj:'cat' ,flt:{cat_name:cat_name} }, {useCache:true})
					.then((objApi) => {  
						//console.log(objApi);
						if(objApi.success && !GVO.isEmpty(objApi.data)){
							this.cats[cat_name]=objApi.data;
				    		this.cats_loading_counter--;
							return objApi.data;
						}else{
							this.cats_loading_counter--;
							console.error('error loading cat = '+cat_name);
						}
					})
					.catch(errorObjApi => console.error(errorObjApi));
			}
		},
		LoadCatPromise(cat_name, forse=false){
			return new Promise(function(resolve, reject) {
				//console.log(cat_name, typeof GVO.cats[cat_name]);
				if(cat_name.length==0){ reject(false); }
				if(GVO.cats[cat_name] == undefined || forse){ 
					GVO.cats_loading_counter++;
					GVO.ApiCall('GET',{obj:'cat' ,flt:{cat_name:cat_name} }, {useCache:true})
						.then((objApi) => {  
							//console.log(objApi);
							if(objApi.success && !GVO.isEmpty(objApi.data)){
								GVO.cats[cat_name]=objApi.data;
								GVO.cats_loading_counter--;
								resolve(true);
							}else{
								GVO.cats_loading_counter--;
								console.error('error loading cat = '+cat_name);
								reject(false);
							}
						})
						.catch(errorObjApi => console.error(errorObjApi));
				}else{
					resolve(true);
				}
			});
		},
		GetCat(cat_name, value,cat_key='id'){
			/*
			if (typeof this.cats[cat_name] == 'undefined'){
				let dmpiscat = await this.LoadCatPromise(cat_name);
			}
			*/
			if (typeof this.cats[cat_name] != 'undefined'){
				if (typeof this.cats[cat_name] != 'undefined'){
					//console.log(cat_key);
					for (let i=0;i<this.cats[cat_name].length;i++){
						if (this.cats[cat_name][i][cat_key] == value){
							return this.cats[cat_name][i];
						}
					}
				}
			}
			return false;
		},
		GetCatValName(cat_name, value, cat_key='id'){
			if (typeof this.cats[cat_name] != 'undefined'){
				let cat_value = GVO.GetCat(cat_name,value,cat_key).name;
				if(typeof cat_value != 'undefined' && cat_value != '' && cat_value != false){
					return cat_value;
				}
			}
			return false;
		},
		getCatToSelect:function(cat_name){
			let objCat = this.cats[cat_name]; 
			let masret = [];
			if(objCat!=undefined){
				for(let oc=0;oc<objCat.length;oc++){
					masret.push({value: objCat[oc].id.toString(), label: objCat[oc].name});
				}
			}
			return masret;
		},
		scrollTop(){
			GVO.ps[1].element.scrollTop = 0;
			GVO.ps[1].update();
			return '';
		},
		startTimerKeepAlive() {
			if(this.timerKeepAlive == null){
				GVO.ApiCall('KEEPALIVE',{obj:'staff'})
					.then((objApi) => {  /*console.log(objApi); this.stopTimerKeepAlive();*/})
					.catch(errorObjApi => console.error(errorObjApi));
				this.timerKeepAlive = setInterval(() => {
					//console.log('KEEPALIVE');
					GVO.ApiCall('KEEPALIVE',{obj:'staff'})
					.then((objApi) => {  if(typeof this.wss.ssend == 'function'){ this.wss.ssend({method:'KEEPALIVE'})} })
					.catch(errorObjApi => console.error(errorObjApi));
				}, 155000);
			}
		},
		stopTimerKeepAlive() {
			clearTimeout(this.timerKeepAlive);
			this.timerKeepAlive = null;
		},
		GetTreeOrgStruct(orgId = '624B713D-2ADE-11E3-AC8E-001E67065AB1'){
			GVO.ApiCall('GET',{obj:'tree' ,flt:{id:orgId} })
			    .then((objApi) => { 
					if(objApi.success === true){
						this.masTreeOrgStruct = objApi.data;
					}
			    }).catch(errorObjApi => console.error(errorObjApi));
		},
		GetTreeOrgStructWithStaff(orgId = '624B713D-2ADE-11E3-AC8E-001E67065AB1'){
			GVO.ApiCall('GET',{obj:'tree' ,flt:{id:orgId,add_staff:true} })
			    .then((objApi) => { 
					if(objApi.success === true){
						this.masTreeOrgStructWithStaff = objApi.data;
					}
			    }).catch(errorObjApi => console.error(errorObjApi));
		},
		showPrompt(strTitle, name){
			return 	swal({
				title: strTitle,
				input:'text',
				inputPlaceholder:name,
				showCloseButton: true,    
			});
		},
		showAlert(strTitle,strHTMLContent,strBtnClasses='btn btn-danger btn-fill'){
			return swal({
				title: strTitle,
				buttonsStyling: false,
				confirmButtonClass: strBtnClasses,
				html: strHTMLContent
			});
		},
		async showYesNo(actionOnYes,strTitle,strText,strYesText='Да',strNotext='Нет'){
			const result = await swal({
				title: strTitle,
				text: strText,
				type: 'warning',
				showCancelButton: true,
				confirmButtonText: strYesText,
				cancelButtonText: strNotext,
				confirmButtonClass: 'btn btn-success btn-fill',
				cancelButtonClass: 'btn btn-danger btn-fill',
				buttonsStyling: false
			});
			if (result.value) {
				//alert('deleted!');
				actionOnYes();
			}
			return result;
		},
		formatAmount(amount){
			return GVO.str_replace(',00','',amount.toLocaleString('ru-RU', { style: 'currency', currency: 'RUB' }));
		},
		number_format( number, decimals, dec_point, thousands_sep ) {	// Format a number with grouped thousands
			// 
			// +   original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
			// +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
			// +	 bugfix by: Michael White (http://crestidg.com)
		
			var i, j, kw, kd, km;
		
			// input sanitation & defaults
			if( isNaN(decimals = Math.abs(decimals)) ){
			decimals = 2;
			}
			if( dec_point == undefined ){
			dec_point = ",";
			}
			if( thousands_sep == undefined ){
			thousands_sep = ".";
			}
		
			i = parseInt(number = (+number || 0).toFixed(decimals)) + "";
		
			if( (j = i.length) > 3 ){
			j = j % 3;
			} else{
			j = 0;
			}
		
			km = (j ? i.substr(0, j) + thousands_sep : "");
			kw = i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands_sep);
			//kd = (decimals ? dec_point + Math.abs(number - i).toFixed(decimals).slice(2) : "");
			kd = (decimals ? dec_point + Math.abs(number - i).toFixed(decimals).replace(/-/, 0).slice(2) : "");
		
		
			return km + kw + kd;
		},
		round(num, decimalPlaces) { // долбаный JS не умеет округлять до определённого количества знаков после запятой
			let d = decimalPlaces || 0,
			m = Math.pow(10, d),
			n = +(d ? num * m : num).toFixed(8),
			i = Math.floor(n), f = n - i,
			e = 1e-8,
			r = (f > 0.5 - e && f < 0.5 + e) ?
				((i % 2 == 0) ? i : i + 1) : Math.round(n);
			return d ? r / m : r;
		},
		Call(phone,obj_type='',obj_id='',objDopParams={}){ 
			/*
				objDopParams - это объект вида:
					{
						ИМЯ_ПОЛЯ_ФИЛЬТРА: ЗНАЧЕНИЕ ЭТОГО ПОЛЯ
					}
			*/
			if (this.hasUserMedia()) { 
				navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
				navigator.getUserMedia({ video: false, audio: true },()=>{
					//console.log('Call успешно');
					let tmpFlt = {'phone':phone,'obj_type':obj_type,'obj_id':obj_id};
					GVO.ApiCall('CALL',{obj:'PhoneCall', flt:{...tmpFlt,...objDopParams}})
						.then((objApi) => {  
							if(objApi.success && !GVO.isEmpty(objApi.data)){
								let t = objApi.data;
								this.PhoneBar.phone=phone;
								this.PhoneBar.call = ats.call(t);
								this.PhoneBar.show=true;
							}
						})
						.catch(errorObjApi => console.error(errorObjApi));
				},function(err){
					// console.log('Call что-то пошло не так',err); 
					GVO.showAlert("Телефония","Нет гарнитуры"); 
					return false;
				}); 
				
			} else {
				this.showAlert("Телефония","Нет гарнитуры или запрет на медиа в браузере"); 
				return false;
				
			}
		},
		hasUserMedia() { 
			if(!navigator.getUserMedia && navigator.mediaDevices && navigator.mediaDevices.getUserMedia){
				navigator.getUserMedia = async function getMedia(constraints,success,error) {
					let stream = null;
				  
					try {
					  stream = await navigator.mediaDevices.getUserMedia(constraints);
					  success(stream)
					} catch(err) {
					  error(err);
					}
				};
			}			
			navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia; 
			return !!navigator.getUserMedia; 
		},
		ApplyTheme(){
			let objTheme = {theme:'0',sidebar_state:'0'};

			if (localStorage.getItem('objTheme')) {
				try {
					objTheme = JSON.parse(localStorage.getItem('objTheme'));
					if(typeof this.my_profile.theme != 'undefined' && typeof this.my_profile.sidebar_state != 'undefined'){
						if(this.my_profile.theme != objTheme.theme || this.my_profile.sidebar_state != objTheme.sidebar_state){
							objTheme.theme = this.my_profile.theme;
							objTheme.sidebar_state = this.my_profile.sidebar_state;
							const parsed = JSON.stringify(objTheme);
							localStorage.setItem('objTheme', parsed);
						}
					}
				} catch(e) {
					localStorage.removeItem('objTheme');
				}
			}else{
				if(typeof this.my_profile.theme != 'undefined' && typeof this.my_profile.sidebar_state != 'undefined'){
					if(this.my_profile.theme != objTheme.theme || this.my_profile.sidebar_state != objTheme.sidebar_state){
						objTheme.theme = this.my_profile.theme;
						objTheme.sidebar_state = this.my_profile.sidebar_state;
						const parsed = JSON.stringify(objTheme);
						localStorage.setItem('objTheme', parsed);
					}
				}
			}

			// действия по примениню темы
			let docClasses = document.body.classList;
			//console.log(objTheme.theme);
			if (objTheme.theme == '1') {
				docClasses.remove('white-content'); //DARK
			} else if (objTheme.theme == '0'){
				docClasses.add('white-content');
			} else {
				docClasses.remove('white-content'); //DARK
			}

			if(objTheme.sidebar_state == '0'){ //выкл - минимизирован
				if(SGVO.$sidebar.isMinimized){
					SGVO.$sidebar.toggleMinimize();
				}
			} else {
				if(!SGVO.$sidebar.isMinimized){
					SGVO.$sidebar.toggleMinimize();
				}
			}
		},
		unlinkObject(obj){
			//return unlinkObject(obj)
			if(obj === undefined) return undefined;
			return  JSON.parse(JSON.stringify(obj));

		},
		parseLink(textOrig){
			let text = textOrig.toString().replace(/(https?:\/\/[^\s]+)/g,function(a){
				return decodeURI((a.replace(/^(https?:\/\/[^\/]+)(\/.*)?(\/[^\?#]+)(\?[^#]*)?(\#.*)?/,function(a,b,c,d,e){
					return b+((c||'').length>0?'/..':'')+d;}))).link(a).replace('<a ','<a target="_blank" class="link" ');
			});
			return text;
		},
		formatPhoneNumber(value) {
			let val = '';
			const startFrom = 7; // С какой цифры начинается номер
			let plus = '+';
			let digit = '7';

			if (startFrom === 8) {
			  plus = '';
			  digit = '8';
			} else {
			  plus = '+';
			  digit = '7';
			} 

			const x = value.toString().replace(/\D/g, '').match(/(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})/);

			if (!x[2] && x[1] !== '') {
			  if(x[1]==='8') x[1] = '7';
			  val = x[1] === digit ? plus + x[1] : plus + digit + x[1];
			} else {
			  if(x[1]==='8') x[1] = '7';
			  val = plus + (!x[3] ? x[1] + x[2] : x[1] + '(' + x[2] + ')' + x[3] + (x[4] ? '-' + x[4] : '') + (x[5] ? '-' + x[5] : ''));
			}
			// console.log(val);
			return val;
		},
		capitalize(val){
			return val && val[0].toUpperCase() + val.slice(1);
		},
		
		switchTheme(){
			clearTimeout(this.timerScheme);
			let docClasses = document.body.classList;
			docClasses.toggle('white-content'); //DARK
			// this.timerScheme = setTimeout(this.switchTheme, 5000+Math.random()*5000);
		},
		handleKeyDown(e) {
			const isCtrl = e.ctrlKey;
			const isAlt = e.altKey;
			const isQ = e.key === 'Q' || e.key === 'q' ||  e.key === 'Й' || e.key === 'й';

			if (isCtrl && isAlt && isQ) {
				this.switchTheme();
			}
		},
	},
	created() {
		if(typeof SGVO!='undefined'){SGVO=this;}
		// console.log('create GVO - OK');
		this.profile_load = new Promise(d=>{
			this.profile_load_cb = d
		})
		this.checkLogin(true);
		this.ats = ats;
		this.ApplyTheme();
		// this.switchTheme();
		document.addEventListener('keydown', this.handleKeyDown);
	},
	beforeDestroy() {
		document.removeEventListener('keydown', this.handleKeyDown);
	},
});

